import { render, staticRenderFns } from "./WithGlossaryEntry.vue?vue&type=template&id=5aaccff0"
import script from "./WithGlossaryEntry.vue?vue&type=script&lang=js"
export * from "./WithGlossaryEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports